<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          :label="$t('name')"
          v-model="editingMenu.name"
          :rules="$rule('required|min3|max128')"
          outlined
          dense
        ></v-text-field>
        <template v-if="!this.menu">
          <v-checkbox
            class="mt-0"
            v-model="clone"
            label="Copiar categorías e items de otro menú"
          />
          <v-select
            v-if="clone"
            label="Copiar de"
            :items="menuOptions"
            v-model="cloneFromId"
            persistent-hint
            hint="Selecciones el menú del cual copiar"
            item-value="id"
            outlined
            dense
            item-text="name"
          ></v-select>
        </template>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text v-if="menu" @click="remove" color="red"
        ><v-icon>mdi-delete</v-icon> {{ $t('delete') }}</v-btn
      >
      <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" @click="save" :disabled="loading || !valid">{{
        $t('save')
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IMenu } from '../../interfaces/IMenu';
  import MenusService from '../../api/services/menus.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import ConfirmModal from './ConfirmModal.vue';
  import { IRestaurant } from '../../interfaces/IRestaurant';

  @Component
  export default class NewMenuModal extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() menu: IMenu;
    @Prop() menuOptions: { id: number | null; name: string }[];
    editingMenu: IMenu = null;
    clone: boolean = false;
    cloneFromId: number | null = null;
    loading = false;
    menusService = new MenusService();
    title = '';
    valid = false;

    async created() {
      if (this.menu) {
        this.editingMenu = { ...this.menu };
      } else {
        this.editingMenu = {
          restaurantId: this.restaurant.id,
          name: null,
        } as IMenu;
      }
    }

    mounted() {
      this.title = !this.menu ? 'Nuevo menú' : `Editando ${this.menu.name}`;
    }

    async save() {
      this.loading = true;
      try {
        let menu = !this.menu
          ? await this.menusService.create(
              this.editingMenu,
              this.clone ? this.cloneFromId : undefined
            )
          : await this.menusService.update(this.editingMenu);
        vueData.addAlert('Menú guardado con éxito', AlertType.Success);

        this.$parent.$emit('saved', menu);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }

    cancel() {
      this.$emit('close');
    }

    async remove() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t('delete.title', { name: this.menu.name }),
          message: this.$t('delete.warning'),
        },
        {
          name: 'delete',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 600,
          clickToClose: false,
        },
        {
          confirm: async () => {
            try {
              await this.menusService.delete(this.menu);
              this.$modal.hide('delete');
              this.$parent.$emit('deleted');
            } catch (e) {
              console.error(e);
              vueData.serverError(e);
            }
          },
        }
      );
    }
  }
</script>
